import { LoadingOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { modes } from '../utils/MaterialListFunctions';

const MaterialTableFooter = ({
  mode, noOfRecords, data, staticWLCount, listCount,
}) => {
  const [displayNr, setDisplayNr] = useState(0);
  const [totalNr, setTotalNr] = useState();

  useEffect(() => {
    if (mode === modes.STATIC) {
      setTotalNr(noOfRecords ?? null);
    } else if (data?.length < 50) {
      setTotalNr(data?.length);
    } else {
      setTotalNr(listCount?.[0]?.NoofRecords ?? null);
    }
  }, [noOfRecords, listCount, data]);

  useEffect(() => {
    if (mode === modes.STATIC) {
      setDisplayNr(staticWLCount ?? 0);
    } else {
      setDisplayNr(data?.length);
    }
  }, [staticWLCount, data]);

  return (
    <div className="tableRecordCount">
      <span>
        {`Showing ${displayNr ?? 0} of `}
        {totalNr ?? <LoadingOutlined spin />}
        {' items'}
      </span>
    </div>

  );
};
export default MaterialTableFooter;
